"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductionCategoryApi = void 0;
var tslib_1 = require("tslib");
/* eslint-disable */
/* 此代码由工具自动生成,不要直接修改,以免下次生成会丢失 */
var di_1 = tslib_1.__importDefault(require("@jsmodules/di"));
var getApi_1 = tslib_1.__importDefault(require("../../getApi"));
var ProductionCategoryApi = /** @class */ (function () {
    function ProductionCategoryApi() {
        this.http = getApi_1.default('api_v1');
    }
    /**
     * 查询商品分类,添加商品分类
     * @method GET 查询商品分类
     * @method POST 添加商品分类
     *
     */
    ProductionCategoryApi.prototype.ProductionCategory = function () {
        return this.http
            .url("/api/ProductionCategory")
            .addSecurityHeaders()
            .support('GET', 'POST');
    };
    /**
     * 修改商品分类,删除商品分类
     * @method PUT 修改商品分类
     * @method DELETE 删除商品分类
     *
     * @params id 无说明
     */
    ProductionCategoryApi.prototype.ProductionCategoryById = function (id) {
        return this.http
            .url("/api/ProductionCategory/" + id)
            .addSecurityHeaders()
            .support('PUT', 'DELETE');
    };
    ProductionCategoryApi.diOptions = di_1.default.options({
        name: "ProductionCategoryApi",
        scope: "Singleton"
    });
    return ProductionCategoryApi;
}());
exports.ProductionCategoryApi = ProductionCategoryApi;
exports.default = ProductionCategoryApi;
